import React from 'react';
import { Button, Result } from 'antd';

const ResetSuccess = () => {
	return (
		<>
			<Result
				status="success"
				title="Successfully Change Password"
				subTitle="Go to login page and try to sign in again"
				extra={[
					<Button type="primary" key="console">
						Go to Login
					</Button>,
					<Button key="buy">Forgot password</Button>,
				]}
			/>
		</>
	);
};

export default ResetSuccess;
